export const TRACK_FINISHED_MESSAGE =
  'Track has completed, please leave feedback to advance';
export const DONE_TEXT = 'Nice Work!';

export const WELCOME_MESSAGE_GENERIC =
  'The artists on ToneBirds would love to hear your feedback, and so would we!';
export const WELCOME_HELP_TEXT = 'Need help? Message the ToneBirds team: ';
export const EMAIL_HELP_URL = 'mailto:info@tonebirds.com';
export const EMAIL_HELP_LINK_TEXT = 'info@tonebirds.com';
export const FINISHED_REVIEWING_TRACKS_TEXT =
  'You have completed reviewing all of your matched tracks. Please check back later for more songs or change your preferred genres to get more tracks.';
export const NON_TONEBIRDS_TRACK =
  'You are listening to a non ToneBirds track, please click refresh below to continue to your ToneBirds session';
